import React, { useMemo, useState } from "react";
import { Input, Button, Popconfirm, Modal, Row, Col, Form, Table, } from "antd";
import { EditOutlined, PlusOutlined, PlusCircleOutlined, DeleteOutlined, } from "@ant-design/icons";
import { useSelector } from "react-redux";
import ButtonComp from "../../../components/button/ButtonComp";
import { findMaxIndex } from "../../../utils/utils"; 

const CustomTab = ({  handleCancel,  editedContract,  contract,  handleSave, }) => {
    const [productEditMode, setProductEditMode] = useState(false);
    const [customModal, setCustomModal] = useState(false);
    const [customFields, setCustomFields] = useState([]);
    const [customFieldsForm] = Form.useForm();
    const select = useSelector((state) => state.auth.userInfo);
    const role = select.role;
    const user_email = select.user_email;
    const user_id = select.user_id;

    let customDFieldsCount = 0;
    if (contract && contract.custom_field) {
        customDFieldsCount = Object.keys(contract.custom_field).length;
    }
    const handleProductEdit = () => setProductEditMode(true);
    let updatedCustomForm = useMemo(
        () => (contract ? { ...contract.custom_field } : {}),
        [contract?.custom_field]
    );

    const handleCustomFormChange = (value, index, name) => {
        const fieldName = `field${index + 1}`;
        const valueName = `value${index + 1}`;
        if (name === "field") {
            updatedCustomForm[fieldName] = value;
        } else if (name === "value") {
            updatedCustomForm[valueName] = value;
        }
    };

    let customFieldsValue = [];
    if (contract?.custom_field) {
        customFieldsValue = Object.keys(contract.custom_field)
            .filter((key) => key.includes("field"))
            .map((key) => ({ field: contract.custom_field[key] || "" }));
    }
    let customValues = [];
    if (contract?.custom_field) {
        customValues = Object.keys(contract.custom_field)
            .filter((key) => key.includes("value"))
            .map((key) => ({ value: contract.custom_field[key] || "" }));
    }
    const combinedCustomList = customFieldsValue.map((fieldObj, index) => ({
        field: fieldObj.field,
        value: customValues[index]?.value,
    }));

    const customTabColumns = [
        {
            title: "Particular",
            dataIndex: "field",
            render: (_, record, index) =>
                productEditMode && editedContract ? (
                    <Input
                        name="field"
                        defaultValue={record.field}
                        onChange={(e) =>
                            handleCustomFormChange(e.target.value, index, e.target.name)
                        }
                    />
                ) : (
                    <h1>{record.field}</h1>
                ),
        },
        {
            title: "Details",
            dataIndex: "value",
            render: (_, record, index) =>
                productEditMode && editedContract ? (
                    <Input
                        name="value"
                        defaultValue={record.value}
                        onChange={(e) =>
                            handleCustomFormChange(e.target.value, index, e.target.name)
                        }
                    />
                ) : (
                    <h1>{record.value}</h1>
                ),
        },
        ...(!productEditMode &&
            !!role &&
            contract &&
            ((contract.editable_user &&
                contract.status !== "EXECUTED" &&
                contract.status !== "TRANSACTION_CLOSED" &&
                parseInt(user_id) === parseInt(contract.editable_user) &&
                (role?.toLowerCase() === "agreement controller head" ||
                    role?.toLowerCase() === "professional agreement controller team" ||
                    role?.toLowerCase() === "professional agreement controller head" ||
                    role === "professional" ||
                    role?.toLowerCase() === "agreement controller team")) ||
                (contract.is_draft && contract.created_by === user_email))
            ? [
                {
                    title: "Delete Field",
                    render: (_, __, index) => (
                        <Popconfirm
                            title="Delete Custom Field"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                                const fieldName = `field${index + 1}`;
                                const valueName = `value${index + 1}`;
                                delete updatedCustomForm[fieldName];
                                delete updatedCustomForm[valueName];
                                handleSave({ custom_field: updatedCustomForm });
                            }}
                        >
                            <Button danger>
                                <DeleteOutlined />
                            </Button>
                        </Popconfirm>
                    ),
                },
            ]
            : []),
    ];

    const handleCustomFieldChange = (index, field, value, id) => {
        const updatedFields = [...customFields];
        updatedFields[index] = { field, value, id };
        setCustomFields(updatedFields);
    };
    const handleAddCustomField = () => {
        setCustomFields([
            ...customFields,
            {
                field: "",
                value: "",
                id:
                    Date.now().toString(36) +
                    Math.random().toString(36).substring(2, 5),
            },
        ]);
    };
    const handleRemoveCustomField = (index) => {
        const updatedFields = [...customFields];
        updatedFields.splice(index, 1);
        setCustomFields(updatedFields);
        customFieldsForm.resetFields();
        const newValues = updatedFields.reduce((acc, f) => {
            acc[`field${f.id}`] = f.field;
            acc[`value${f.id}`] = f.value;
            return acc;
        }, {});
        customFieldsForm.setFieldsValue(newValues);
    };
    const handleCustomFieldSave = async () => {
        try {
            await customFieldsForm.validateFields();
            const data = customFields.reduce((acc, item, index) => {
                const fieldIndex =
                    index + findMaxIndex(contract && contract.custom_field);
                return {
                    ...acc,
                    [`field${fieldIndex + 1}`]: item.field,
                    [`value${fieldIndex + 1}`]: item.value,
                };
            }, {});
            if (!Object.values(data).length) {
                throw new Error("Add at least one custom field");
            }
            handleSave({ custom_field: { ...contract.custom_field, ...data } });
            setCustomModal(false);
            setCustomFields([]);
            customFieldsForm.resetFields();
        } catch (err) {
            console.error(err.message);
        }
    };

    return (
        <div>
            <div className="text-black pb-5 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between">
                <div className="agreement-details flex justify-between items-center">
                    <h1 className="mt-1 font-semibold text-[15px] pt-[5%] dark:text-white">
                        Custom Tab
                    </h1>
                    {customDFieldsCount !== 0 &&
                        role &&
                        contract &&
                        ((contract.editable_user &&
                            contract.status !== "EXECUTED" &&
                            contract.status !== "TRANSACTION_CLOSED" &&
                            parseInt(user_id) === parseInt(contract.editable_user) &&
                            (role?.toLowerCase() === "agreement controller head" ||
                                role?.toLowerCase() === "professional agreement controller team" ||
                                role?.toLowerCase() === "professional agreement controller head" ||
                                role === "professional" ||
                                role?.toLowerCase() === "agreement controller team")) ||
                            (contract.is_draft && contract.created_by === user_email)) ? (
                        !productEditMode &&
                        editedContract && (
                            <EditOutlined
                                onClick={handleProductEdit}
                                className="ml-2 text-lg transform scale-125 hover:scale-150 transition-transform duration-300 cursor-pointer"
                            />
                        )
                    ) : null}
                </div>

                <div className="mt-4 flex flex-row gap-2">
                    {productEditMode ? (
                        <>
                            <ButtonComp
                                width="7em"
                                text="Cancel"
                                onClick={handleCancel}
                                textColor="#4E36A3"
                            />
                            <ButtonComp
                                width="7em"
                                type="primary"
                                onClick={() => {
                                    handleSave({ custom_field: updatedCustomForm });
                                    setProductEditMode(false); // ✅ close edit mode after save
                                }}
                                text="Save"
                                textColor="white"
                                bgColor="#4E36A3"
                            />
                        </>
                    ) : (
                        !!role &&
                        contract &&
                        ((contract.editable_user &&
                            contract.status !== "EXECUTED" &&
                            contract.status !== "TRANSACTION_CLOSED" &&
                            parseInt(user_id) === parseInt(contract.editable_user) &&
                            (role?.toLowerCase() === "agreement controller head" ||
                                role?.toLowerCase() === "professional agreement controller team" ||
                                role?.toLowerCase() === "professional agreement controller head" ||
                                role === "professional" ||
                                role?.toLowerCase() === "agreement controller team")) ||
                            (contract.is_draft && contract.created_by === user_email)) && (
                            <button
                                className="h-12 w-[15rem] rounded-[10px] border border-[#d8bfd8] hover:text-[#800080] bg-white"
                                onClick={() => setCustomModal(true)}
                            >
                                <PlusOutlined /> Add More
                            </button>
                        )
                    )}
                </div>
            </div>

            <Modal
                title="Add Custom Fields"
                open={customModal}
                onOk={handleCustomFieldSave}
                onCancel={() => setCustomModal(false)}
                okText="Save"
                okButtonProps={{
                    style: { backgroundColor: "#4E36A3", color: "white" },
                }}
            >
                <Form
                    autoComplete="off"
                    form={customFieldsForm}
                    onFinish={handleCustomFieldSave}
                >
                    {customFields.map((field, index) => {
                        const fieldIndex =
                            index + findMaxIndex(contract && contract.custom_field);
                        return (
                            <Row gutter={16} key={field.id}>
                                <Col span={8}>
                                    <Form.Item
                                        label={`Particular ${fieldIndex + 1}`}
                                        name={`field${field.id}`}
                                        rules={[{ required: true, message: "Please enter field" }]}
                                    >
                                        <Input
                                            value={field.field}
                                            onChange={(e) =>
                                                handleCustomFieldChange(
                                                    index,
                                                    e.target.value,
                                                    field.value,
                                                    field.id
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={`Details ${fieldIndex + 1}`}
                                        name={`value${field.id}`}
                                        rules={[{ required: true, message: "Please enter value" }]}
                                    >
                                        <Input.TextArea
                                            value={field.value}
                                            onChange={(e) =>
                                                handleCustomFieldChange(
                                                    index,
                                                    field.field,
                                                    e.target.value,
                                                    field.id
                                                )
                                            }
                                            style={{ height: "32px" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Button danger onClick={() => handleRemoveCustomField(index)}>
                                        <DeleteOutlined />
                                    </Button>
                                </Col>
                            </Row>
                        );
                    })}
                </Form>
                <Button type="dashed" onClick={handleAddCustomField} block>
                    <PlusCircleOutlined /> Add Custom Field
                </Button>
            </Modal>
            <Table
                dataSource={combinedCustomList}
                columns={customTabColumns}
                pagination={false}
                scroll={{ x: "max-content" }}
                bordered
                rowKey={(record, index) => index}
            />
        </div>
    );
};

export default CustomTab;
